import { render, staticRenderFns } from "./employee-edit.vue?vue&type=template&id=65ba1674"
import script from "./employee-edit.vue?vue&type=script&lang=js"
export * from "./employee-edit.vue?vue&type=script&lang=js"
import style0 from "./employee-edit.vue?vue&type=style&index=0&id=65ba1674&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports